import { createAxiosInstance } from './axiosInstance';
import { microservices } from '@constants/microServices';

export const edgeApi = createAxiosInstance(microservices.edgeNest);
export const syncApi = createAxiosInstance(microservices.sync);
export const contactsApi = createAxiosInstance(microservices.contactsNest);
export const authApi = createAxiosInstance(microservices.auth);
